import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Counseling = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my counseling business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps counseling businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for counseling businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most counseling businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my counseling business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like counseling. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Counseling - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Counseling CRM", url: "/industries/counseling" }
  ];

  const industryData = {
    name: 'Counseling & Therapy',
    title: 'Fill Your Practice & Reduce No-Shows by 50%',
    subtitle: 'Automate appointment reminders, manage client intake, and build a thriving private practice',
    icon: '🧑‍⚕️',
    challenges: [
      'High no-show rates affect revenue',
      'Intake paperwork is time-consuming',
      'Hard to keep consistent schedule',
      'Insurance pre-authorization delays',
      'Client retention is challenging'
    ],
    solutions: [
      'Automated appointment reminders',
      'Digital intake form automation',
      'Consistent scheduling optimization',
      'Insurance verification tracking',
      'Client engagement campaigns'
    ],
    features: [
      'Client portal with secure messaging',
      'Online appointment booking',
      'Digital intake forms',
      'Appointment reminders',
      'Insurance tracking',
      'Session notes (HIPAA compliant)',
      'Payment automation',
      'Telehealth integration'
    ],
    results: [
      '50% reduction in no-shows',
      '90% schedule utilization',
      '75% client retention rate',
      '£7.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Counseling UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for counseling businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for counseling UK, counseling business software, counseling customer management, counseling lead generation UK"
        url="/industries/counseling"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Counseling;